import { useContext, useEffect, useState } from "react";
import { HistoryContainer } from "../History/styled";
import TableCommon from "../../../components/Common/TableCommon";
import { ContextProviderWrapper } from "../../../components/Context";
import { ContentTableMobile } from "../../Avax/Leaderboard/styled";
import { AVAX_API } from "../../../services/api/indexV2";
import { shortenAddress } from "../../../utils/addressUser";
import moment from "moment";
import { convertFixed } from "../../../utils/convertNumber";

const Launchpad = () => {
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;
  const [page, setPage] = useState(1);
  const [idoData, setIdoData] = useState([]);
  const headingData = !isMobile
    ? [
        {
          name: `Round ID`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return <p>{shortenAddress(data?.round_id)}</p>;
          },
        },
        {
          name: `Registration Date`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return <p>{moment(data.createdAt).format("MMMM DD HH:mm")}</p>;
          },
        },
        {
          name: `Amount USD`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return <p>${convertFixed(data.amount_usd)}</p>;
          },
        },
        {
          name: `Amount Token`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return <p>{convertFixed(data.amount_token)}</p>;
          },
        },
        // {
        //   name: `Allocation`,
        //   dataIndex: "allocation",
        //   key: "allocation",
        //   render: (data: any) => {
        //     return <p>{data}</p>;
        //   },
        // },
        {
          name: `Status`,
          dataIndex: "is_success",
          key: "is_success",
          render: (data: any) => {
            return (
              <span className={`tag ${theme} ${data ? "is-success" : ""}`}>
                <span>{data ? "success" : "failed"}</span>
              </span>
            );
          },
        },
        // {
        //   name: `Earned Points`,
        //   dataIndex: "points",
        //   key: "points",
        //   render: (data: any) => {
        //     return <p>{data}</p>;
        //   },
        // },
      ]
    : [
        {
          name: `Transaction`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              <ContentTableMobile className={theme}>
                <div className="content-right">
                  <div className="block-address">
                    <p className="address">{data.projectName}</p>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Round ID: <span>{shortenAddress(data?.round_id)}</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Date:{" "}
                        <span>
                          {" "}
                          {moment(data.createdAt).format("MMMM DD HH:mm")}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Amount USD:{" "}
                        <span>${convertFixed(data.amount_usd)}</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Amount Token:{" "}
                        <span>{convertFixed(data.amount_token)}</span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Status:{" "}
                        <span
                          className={`tag ${theme} ${data ? "is-success" : ""}`}
                        >
                          <span>{data ? "success" : "failed"}</span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ContentTableMobile>
            );
          },
        },
      ];

  const data = [
    {
      projectName: "Project X",
      time: "2025-05-20",
      allocation: "1000 $ABC",
      amount: 500,
      points: 10,
      status: "Received",
    },
    {
      projectName: "Project X",
      time: "2025-05-20",
      allocation: "1000 $ABC",
      amount: 500,
      points: 10,
      status: "Received",
    },
    {
      projectName: "Project X",
      time: "2025-05-20",
      allocation: "1000 $ABC",
      amount: 500,
      points: 10,
      status: "refund",
    },
    {
      projectName: "Project X",
      time: "2025-05-20",
      allocation: "1000 $ABC",
      amount: 500,
      points: 10,
      status: "success",
    },
    {
      projectName: "Project X",
      time: "2025-05-20",
      allocation: "1000 $ABC",
      amount: 500,
      points: 10,
      status: "Received",
    },
  ];
  const moveToDetail = "leaderboard";
  const handleGetIDOTransaction = async () => {
    try {
      const params = {
        page,
      };
      const res = await AVAX_API.getIDOTransaction(params);
      if (res && res.status === 200) {
        setIdoData(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetIDOTransaction();
  }, []);

  return (
    <HistoryContainer>
      <TableCommon
        data={idoData}
        heading={headingData}
        moveTo={moveToDetail}
        pagination={data.length > 10 ? true : false}
      />
    </HistoryContainer>
  );
};

export default Launchpad;
